// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0abc92f2","455":"b987daa1","977":"f958ea0f"}[chunkId] + ".chunk.js";
};